import LanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import ProgressGameModel from "../../save-game/model/ProgressGameModel";
import DashboardData from "../model/DashboardData";
import DashboardSingleData from "../model/DashboardSingeData";
import DashboardNumberChartMediator from "../view/DashboardNumberChartMediator";

export default class DashboardNumberChartFactory {
    /**
     * @param {MediatorManager} mediatorManager 
     * @param {DashboardData} dashboardData 
     * @param {LanguagePack} languagePack 
     * @param {ProgressGameModel} progressGameModel 
     */
    constructor(mediatorManager, dashboardData, languagePack, progressGameModel) {
        this._mediatorManager = mediatorManager;
        this._dashboardData = dashboardData;
        this._languagePack = languagePack;
        this._progressGameModel = progressGameModel;
    }

    createNumberChart(container, config, mode) {
        /** @type {DashboardNumberChartMediator} */
        let numberChartMediator = this._mediatorManager.createMediator(container, SkinKeyRegistry.DASHBOARD_NUMBER_CHART_SKIN);
        this.setDataNumberChart(numberChartMediator, config, mode);
        return numberChartMediator;
    }
    /**
     * @param {DashboardNumberChartMediator} numberChartMediator
     * */
    setDataNumberChart(numberChartMediator, config, mode) {
        const chapter = this._progressGameModel.chapter;
        const week = this._progressGameModel.week;
        const path = this._progressGameModel.path;

        if (mode !== DashboardNumberChartFactory.EPI_DATA && mode !== DashboardNumberChartFactory.HEALTH_SYSTEMS) {
            return;
        }

        let previousData = null;
        previousData = (mode === DashboardNumberChartFactory.EPI_DATA ?
            this._dashboardData.getPreviousEpiData(chapter, week, path) :
            this._dashboardData.getPreviousHealthSystems(chapter, week, path)
        );


        let currentData = (mode === DashboardNumberChartFactory.EPI_DATA ?
            this._dashboardData.getCurrentEpiData(chapter, week, path) :
            this._dashboardData.getCurrentHealthSystems(chapter, week, path)
        );

        let number = 0;
        let percent = 0;
        let increase = 0;
        if (currentData != null) {
            number = currentData[config.column];
            if (previousData != null) {
                var currentNumber = (currentData[config.column] + "").replace('%', '');
                var previousNumber = (previousData[config.column] + "").replace('%', '');
                percent = (previousData == null ? 0 : (currentNumber / previousNumber - 1) * 100).toFixed(1);
                increase = (previousData == null ? 0 : percent >= 0);
            }
        }

        var dashboardSingleData = new DashboardSingleData(
            this._languagePack.getText(config.localizedLabel),
            number,
            percent,
            increase,
            config.greenTrendOnPositiveData
        );

        let showTrend = true;
        
        if(previousData === null || previousData === undefined) {
            showTrend = false
        }
        numberChartMediator.setData(dashboardSingleData, showTrend);
    }
}
DashboardNumberChartFactory.EPI_DATA = "epidata";
DashboardNumberChartFactory.HEALTH_SYSTEMS = "health-systems";